import { thunk } from 'redux-thunk';

import store from 'store';

// getDefaultMiddleware was removed as a standalone export in RTK 2.0.
// The only middleware we need from it is thunk (for RTK Query support).
// The serializable check was already disabled, and dev-mode invariant
// checks are not critical for the rematch-managed store.
store.addMiddleware(thunk);
